export function isUUID(maybeUUID: string): boolean {
  return /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(maybeUUID);
}
